// Which client (department) the staff user is currently looking at. Kept outside React so the
// API layer can read it synchronously when it builds a request header.

const KEY = "grc_selected_client";

/** Special selection for staff: show every department together (read-only). */
export const ALL_DEPARTMENTS = "ALL";

// Used by the "All departments" view to ask the sample-data mock about one department at a time.
let override = null;

export function getSelectedClientId() {
  if (override != null) return override;
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function setSelectedClientId(id) {
  try {
    if (id == null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(id));
  } catch {
    /* storage unavailable: selection just won't persist */
  }
}

export const isAllSelected = () => getSelectedClientId() === ALL_DEPARTMENTS;

/** Runs fn (synchronously starts its request) as if `id` were the selected department. */
export function withClient(id, fn) {
  const previous = override;
  override = String(id);
  try {
    return fn();
  } finally {
    override = previous;
  }
}
